import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ContactUsFloatButtonComponent } from '@components';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-root',
    imports: [ToastModule, RouterOutlet, ContactUsFloatButtonComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {}
